import type {Dispatch, SetStateAction} from "react";
import {GenericModal} from "~/components/genericModal";
import {AnankeButton} from "@vesta/ananke/components/anankeButton";
import {AnankeText} from "@vesta/ananke/components/anankeText";
import {VerticalSpacer} from "@vesta/global-common-typescript/components/verticalSpacer";

export type RestoreItemType = "event" | "journey";

export function RestoreConfirmationModal({
    isOpen,
    setIsOpen,
    itemType: _itemType,
    onConfirm,
    isLoading,
}: {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    itemType: RestoreItemType;
    onConfirm: () => Promise<void>;
    isLoading: boolean;
}) {
    void _itemType;

    return (
        <GenericModal
            onClose={() => setIsOpen(false)}
            opened={isOpen}
            withCloseButton={false}
            title="Are you sure you want to restore?"
            size="sm"
            zIndex={10000}
        >
            <AnankeText
                size="medium"
                color="color.text.subtle"
            >
                Restoring this data will make the user active again
            </AnankeText>

            <VerticalSpacer className="h-4" />

            <div className="w-full grid grid-flow-col justify-end gap-2">
                <AnankeButton
                    type="button"
                    onClick={() => setIsOpen(false)}
                    appearance="default"
                    isDisabled={isLoading}
                >
                    Cancel
                </AnankeButton>

                <AnankeButton
                    type="button"
                    appearance="primary"
                    onClick={async () => {
                        await onConfirm();
                    }}
                    isLoading={isLoading}
                >
                    Restore
                </AnankeButton>
            </div>
        </GenericModal>
    );
}
